<template>
  <div class="menu-list-container">
    <div class="left-panel">
      <div class="toolbar">
        <a-button @click="handleAdd" type="primary" icon="plus">{{ $t('investorList.s8') }}</a-button>
      </div>
      <a-directory-tree
        multiple
        default-expand-all
        :tree-data="treeData"
        :selectedKeys="selectedKeys"
        @select="onSelect"
        @expand="onExpand"
      >
        <template slot="title" slot-scope="node">
          <span>{{ node.title }}</span>
        </template>
      </a-directory-tree>
    </div>
    <div class="right-panel" v-if="selectedNode">
      <div class="detail-header">
        <h2>{{ $t('investorList.cz') }}</h2>
        <div class="header-actions">
          <a-button @click="handleEdit(selectedNode)" type="primary">{{ $t('edit') }}</a-button>
          <a-button @click="handleDelete(selectedNode.id)" type="danger" style="margin-left: 10px">{{
            $t('delete')
          }}</a-button>
        </div>
      </div>
      <div class="detail-content">
        <div class="detail-row">
          <span class="label">{{ $t('investorList.s10') }}</span>
          <span class="value">{{ getMenuTypeName(selectedNode.tempMenuType || selectedNode.menuType) }}</span>
        </div>
        <div class="detail-row">
          <span class="label">{{ $t('investorList.s11') }}</span>
          <span class="value">
            <a-tag v-if="selectedNode.nameEn">{{ selectedNode.nameEn }}</a-tag>
            <a-tag v-if="selectedNode.nameEs">{{ selectedNode.nameEs }}</a-tag>
            <a-tag v-if="selectedNode.nameMs">{{ selectedNode.nameMs }}</a-tag>
            <a-tag v-if="selectedNode.nameAr">{{ selectedNode.nameAr }}</a-tag>
          </span>
        </div>
        <div class="detail-row">
          <span class="label">{{ $t('investorList.s12') }}</span>
          <span class="value">{{ selectedNode.menuPath || '-' }}</span>
        </div>
        <div class="detail-row">
          <span class="label">{{ $t('investorList.s13') }}</span>
          <span class="value">{{ selectedNode.component || '-' }}</span>
        </div>
        <div class="detail-row">
          <span class="label">{{ $t('investorList.s14') }}</span>
          <span class="value"><a-icon :type="selectedNode.menuIcon" /></span>
        </div>
        <div class="detail-row">
          <span class="label">{{ $t('investorList.s15') }}</span>
          <span class="value">{{ selectedNode.menuSort }}</span>
        </div>
        <div class="detail-row">
          <span class="label">{{ $t('investorList.s16') }}</span>
          <span class="value">{{ selectedNode.hidden === 0 ? $t('investorList.s17') : $t('investorList.s18') }}</span>
        </div>
      </div>
    </div>
    <div class="right-panel" v-else>
      <div class="empty-tip">{{ $t('platformCollection.please_select_menu_item') }}</div>
    </div>
    <permission-modal ref="modalForm" :menu-tree="menuTree" :only-btn="onlyBtn" @ok="modalFormOk"></permission-modal>
  </div>
</template>
<script>
const I18N_KEY = 'system.menuList.'
import { mapActions, mapGetters } from 'vuex'
import lang from '@/i18n/lang/'
import PermissionModal from '../modules/PermissionModal'

export default {
  components: {
    PermissionModal,
  },
  data() {
    return {
      I18N_KEY,
      loading: false,
      menuForm: {
        parentId: undefined,
      },
      onlyBtn: false,
      selectedKeys: [],
      selectedNode: null,
    }
  },
  computed: {
    ...mapGetters('system', ['menuListTree']),
    ...mapGetters('language', ['languageStorage']),
    menuList() {
      const formatList = (list) => {
        return list.map((item) => {
          return {
            ...item,
            children: item.children && item.children.length ? formatList(item.children) : undefined,
          }
        })
      }
      return formatList(this.menuListTree || [])
    },
    menuTree() {
      return this.transformMenuListToTree(this.menuList)
    },
    treeData() {
      const transformToTreeData = (list) => {
        return list.map((item) => {
          let title = item.nameEn || ''
          if (this.languageStorage === lang.esUS) {
            title = item.nameEs || item.nameEn || ''
          }
          return {
            key: '' + item.id,
            title: title,
            ...item,
            children: item.children && item.children.length ? transformToTreeData(item.children) : [],
          }
        })
      }
      return transformToTreeData(this.menuList)
    },
  },
  created() {
    window.xx = this
    this.loadData()
  },
  methods: {
    ...mapActions('system', ['getMenuListTree', 'addMenu', 'editMenu', 'deleteMenu']),
    transformMenuListToTree(list) {
      return list.map((item) => {
        let label = item.nameEn || ''
        if (this.languageStorage === lang.esUS) {
          label = item.nameEs || item.nameEn || ''
        }
        return {
          ...item,
          value: '' + item.id,
          label: label,
          key: '' + item.id,
          children: item.children && item.children.length && this.transformMenuListToTree(item.children),
        }
      })
    },
    onSelect(selectedKeys, { selected, node, selectedNodes }) {
      console.log('onSelect', selectedKeys, selected, node, selectedNodes)
      this.selectedKeys = selectedKeys
      if (selected && node) {
        this.selectedNode = node.dataRef
      } else {
        this.selectedNode = null
      }
    },
    onExpand(expandedKeys, { expanded, node, expandedNodes }) {
      console.log('onExpand', expandedKeys, expanded, node, expandedNodes)
    },
    getMenuTypeName(type) {
      const typeMap = {
        0: this.$t('platformCollection.first_level_menu'),
        1: this.$t('platformCollection.sub_menu'),
        2: this.$t('platformCollection.button_permission'),
      }
      return typeMap[type] || type
    },
    modalFormOk(data) {
      console.log('xxxxx', data)
      // Reload list after add/edit success
      this.submitMenu(data)
    },
    handleAdd() {
      this.menuId = undefined
      this.$refs.modalForm.add()
      this.$refs.modalForm.title = this.$t('platformCollection.add_new')
      this.$refs.modalForm.disableSubmit = false
    },
    handleEdit(record) {
      this.menuId = record.id
      this.onlyBtn = record.menuType == 2
      record.tempMenuType = record.menuType == 2 ? 2 : record.parentId == '0' ? 0 : 1
      // record.parentId
      this.$refs.modalForm.localMenuType = record.tempMenuType
      this.$refs.modalForm.edit(record)
      this.$refs.modalForm.title = this.$t('platformCollection.edit')
      this.$refs.modalForm.disableSubmit = false
    },
    handleDataRule(record) {
      this.$refs.PermissionDataRuleList.edit(record)
    },
    handleAddSub(record) {
      this.menuId = undefined
      const data = {
        menuType: 1,
        tempMenuType: 1,
        parentId: '' + record.id,
        hidden: 0,
      }
      this.$refs.modalForm.localMenuType = 1
      this.$refs.modalForm.title = this.$t('platformCollection.add_sub_menu')
      this.$refs.modalForm.disableSubmit = false
      this.$refs.modalForm.edit(data)
    },
    handleDelete(id) {
      this.loading = true
      this.deleteMenu({ menuId: id })
        .then((res) => {
          this.loadData()
        })
        .catch((e) => {
          this.loading = false
          this.$message.error(e.message)
        })
    },
    submitMenu(data) {
      this.$refs.modalForm.openLoading()
      data.id = this.menuId
      const requestField = this.menuId ? 'editMenu' : 'addMenu'
      this[requestField](data)
        .then((res) => {
          this.$refs.modalForm.closeLoading()
          this.$refs.modalForm.close()
          this.$message.success(this.$t('platformCollection.add_success'))
          this.loadData()
        })
        .catch((e) => {
          this.$refs.modalForm.closeLoading()
          this.$message.error(e.message)
        })
    },
    loadData() {
      this.loading = true
      this.getMenuListTree()
        .then((res) => {
          this.loading = false
        })
        .catch((e) => {
          this.loading = false
          this.$message.error(e.message)
        })
    },
  },
}
</script>
<style scoped>
@import '~@/assets/less/common.less';

.menu-list-container {
  display: flex;
  height: calc(100vh - 130px);
}

.left-panel {
  width: 500px;
  border-right: 1px solid #e8e8e8;
  padding: 16px;
  overflow-y: auto;
}

.right-panel {
  flex: 1;
  padding: 24px;
  overflow-y: auto;
}

.toolbar {
  margin-bottom: 16px;
}

.detail-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e8e8e8;
}

.detail-header h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
}

.header-actions {
  display: flex;
  gap: 10px;
}

.detail-content {
  max-width: 800px;
}

.detail-row {
  display: flex;
  margin-bottom: 20px;
  align-items: flex-start;
}

.detail-row .label {
  width: 130px;
  color: #666;
  flex-shrink: 0;
  line-height: 28px;
}

.detail-row .value {
  flex: 1;
  line-height: 28px;
}

.empty-tip {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  color: #999;
  font-size: 16px;
}
</style>
